import { useEffect } from 'react';

import type { PremiumOffer } from '@shared/dream-components/src';

import { useNonRevalidatingFetcher } from '~/hooks/useNonRevalidatingFetcher';

interface Props {
  enabled: boolean;
  tierId?: string;
  priceId?: string;
}

interface ReturnProps {
  isLoading: boolean;
  data?: PremiumOffer[];
  enabled?: boolean;
}

const useStaticRetentionPremiumOffers = ({ enabled, tierId, priceId }: Props): ReturnProps => {
  const fetcher = useNonRevalidatingFetcher<() => Promise<PremiumOffer[]>>();

  const searchParams = new URLSearchParams();
  if (tierId) {
    searchParams.append('tier_id', tierId);
  }
  if (priceId) {
    searchParams.append('price_id', priceId);
  }

  const url = searchParams.size ? `/retention_premium_offers?${searchParams.toString()}` : '/retention_premium_offers';

  // biome-ignore lint/correctness/useExhaustiveDependencies: If we included fetcher, it would refetch constantly
  useEffect(() => {
    if (enabled) {
      fetcher.load(url);
    }
  }, [enabled, tierId]);

  const isLoading = fetcher.state === 'loading' || (!fetcher?.data && enabled);

  return {
    isLoading: isLoading && enabled,
    data: fetcher?.data || [],
  };
};

export default useStaticRetentionPremiumOffers;
